import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, commsHeader, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_COMS_BENEFIT, GET_COMS_BENEFIT_SUCCESS, GET_COMS_BENEFIT_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getComsBenefit({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/comms/general/settings`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        ...commsHeader,
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_COMS_BENEFIT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_COMS_BENEFIT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COMS_BENEFIT_ERROR, payload: error });
  }
}

export function* watchComsBenefit() {
  yield takeEvery(GET_COMS_BENEFIT, getComsBenefit);
}

function* getComsBenefitSaga() {
  yield all([fork(watchComsBenefit)]);
}

export default getComsBenefitSaga;
